<!--
 * @Author: DESKTOP-6JOF46S\蔡洋杰 1760178806@qq.com
 * @Date: 2023-10-06 09:37:23
 * @LastEditors: DESKTOP-6JOF46S\蔡洋杰 1760178806@qq.com
 * @LastEditTime: 2023-10-06 09:44:22
 * @FilePath: \合联\oms\src\view\analysis\tm_track\index.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <cTable :apis="methods" tm> </cTable>
</template>

<script>
import cTable from "../tt_track/index";
import { apis } from "@/api/analysis/tm_track";

// import format from "@/utils/format";
// import expandRow from "_my/table-expand";
export default {
  name: "tt_track",
  components: {
    cTable
  },
  methods: {},
  data() {
    return {
      methods: apis
    };
  },
  mounted() {}
};
</script>
